<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab title="Paid Tournament">
            <hr />
            <!-- <PaidTournament></PaidTournament> -->
          </CTab>

          <CTab title="Free Tournament">
            <hr />
            <!-- <FreeTournament></FreeTournament> -->
          </CTab>
        
            <!-- <CTab title="Tournament Users">
            <hr />
            <TournamentUsers></TournamentUsers>
          </CTab> -->
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>

<script>

// import PaidTournament from "./paidTournament.vue";
// import FreeTournament from "./freeTournament.vue";
export default {
  components: {
    // PaidTournament,
    // FreeTournament
  },
};
</script>

<style></style>
